import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDateTo'
})
export class ExtractDateToPipe implements PipeTransform {

  transform(value: string, args: string[]): any {
      return value.substr(value.length-20,10).split("_").join("-");
  }

}
